<form>
  <div class="modal-header" ngxModalDraggable>
    <h3 class="me-4">
      {{title}}
    </h3>
    <button type="button" class="btn-close ms-auto" aria-label="Close" (click)="close(jsonContent)">
    </button>
  </div>
  <div class="modal-body">
    <app-json-editor *ngIf="json" [options]="editorOptions" [json]="json" [debug]="true" (changeContent)="changeJson($event)" (change)="changeJson($event)"/>
  </div>
  <mes-web-edit-modal-buttons *ngIf="hasSaveButtons"
                              [entityId]="entityId"
                              (saveClick)="save($event)"
                              (cancelClick)="bsModalRef.dismiss()"/>
</form>
